import React from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import LMSAPI from './api.js';
import Header from './header.js';
import Navigation from './navigation.js';
import LMSMain from './lmsmain.js';
import Register from '../registration/register.js';
import Login from '../login.js';
import CourseCatalog from '../course/catalog/coursecatalog.js';
import CourseCatalogEmbed from '../course/catalog/coursecatalog_embed.js';
import CourseInfo from '../course/catalog/courseinfo.js';
import Course from '../course/course.js';
import Cart from '../course/catalog/cart.js';
import ResetPassword from '../resetpassword.js';
import PasswordChange from '../passwordchange.js';
import Auth from './auth.js';
import FormViewer from '../forms/formviewer.js';

export default class LMSApp extends React.Component
{
    constructor(props)
    {
        super(props);
        this.authenticate = this.authenticate.bind(this);
        this.logout = this.logout.bind(this);
        this.passwordChanged = this.passwordChanged.bind(this);
        this.loadCart = this.loadCart.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.removeFromCart = this.removeFromCart.bind(this);
        this.clearCart = this.clearCart.bind(this);
        this.buytypeChanged = this.buytypeChanged.bind(this);
        this.checkCartUserChanged = this.checkCartUserChanged.bind(this);
        this.cartUserSelectAll = this.cartUserSelectAll.bind(this);
        this.cartUserDeselectAll = this.cartUserDeselectAll.bind(this);
        this.state = {
            api: new LMSAPI(),
            loaded: false,
            authenticated: false,
            changepassword: false,
            orgUsers: [],
            cart: {
                loaded: false,
                buyType: 0,
                grandTotal: 0,
                cartCourses: [],
                carUsers: []
            }
        }
    }
    componentDidMount()
    {
        this.checkAuth();
        this.loadOrgUsers();
        this.loadCart();
    }
    authenticate(event, callback)
    {
        const authForm = new FormData(event.target);
        const authData = {};
        authForm.forEach(function(value, key) {
            authData[key] = value.trim();
        });
        this.state.api.send({
            controller: "Authentication",
            action: "Authenticate",
            method: "post",
            body: JSON.stringify(authData),
            success: (result) => {
                if (result.success)
                {
                    if (authData['rememberMe'] && authData['rememberMe'].checked)
                    {
                        localStorage.setItem("LMSToken", result.token);
                    }
                    else
                    {
                        sessionStorage.setItem("LMSToken", result.token);
                    }
                    this.setState({authenticated: true, changepassword: result.changePassword}, () => { this.loadOrgUsers(); this.loadCart(); });
                }
                else
                {
                    callback(result);
                }
            },
            error: (err) => {
                callback(err);
            }
        });
    }
    passwordChanged()
    {
        this.setState({changepassword: false});
    }
    checkAuth()
    {
        new Auth().checkAuth(this.state.api, (result) => {
            result.changepassword ? 
            this.setState({authenticated: true, loaded: true, changepassword: true}) :
            this.setState({authenticated: true, loaded: true});
        }, (err) => {
            this.setState({loaded: true});
        });
    }
    logout(e) 
    {
        if (localStorage.getItem("LMSToken") != null) 
        {
            localStorage.removeItem("LMSToken");
        }
        if (sessionStorage.getItem("LMSToken") != null) 
        {
            sessionStorage.removeItem("LMSToken");
        }
        this.setState({authenticated: false});
    }
    loadCart()
    {
        var cart = this.state.cart;
        cart.loaded = false;
        this.setState({cart: cart}, () => {
            this.state.api.send({
                controller: "Cart",
                action: "LoadCart",
                method: "get",
                success: (result) => {
                    this.setState({cart: { 
                        loaded: true,
                        grandTotal: 0.00,
                        buyType: result.buyType, 
                        cartCourses: result.cartCourses,
                        cartUsers: result.cartUsers
                    }}, () => this.calcPrice());
                },
                error: (err) => {
                    this.setState({loaded: true});
                }
            })
        });
    }
    calcPrice()
    {
        var courseList = this.state.cart.cartCourses;
        var grandTotal = 0.00;
        courseList.forEach((c) => {
            c.courseTotal = 0.00;
            c.unitPrice = c.coursePrice;
            Number(this.state.cart.buyType) === 1 ? 
                c.usrCount = this.state.orgUsers.length 
                : Number(this.state.cart.buyType) === 2 ?
                c.usrCount = this.state.cart.cartUsers.length
            : c.usrCount = 1
                c.courseVolumeDiscounts.map((d) => {
                    return c.usrCount >= d.userThreshold ? c.unitPrice = d.price : null
                })
            c.courseTotal = c.unitPrice * c.usrCount;
            grandTotal += c.courseTotal;
            this.setState({
                cart: { 
                    loaded: true,
                    cartCourses: courseList,
                    cartUsers: this.state.cart.cartUsers,
                    buyType: this.state.cart.buyType,
                    grandTotal: grandTotal
                }
            });
        });
    }
    loadOrgUsers()
    {
        this.setState({loaded: false})
        this.state.api.send({
            controller: "Organization",
            action: "GetUsers",
            method: "get",
            success: (result) => {
                result.success ?
                    this.setState({loaded: true, orgUsers: result.users}) :
                    this.setState({loaded: true, error: true})
            },
            error: (err) => {
                this.setState({loaded: true, error: true})
            }
        })
    }
    addToCart(e, course)
    {
        e.preventDefault();
        this.setState({loaded: false}, () => {
            this.state.api.send({
                controller: "Cart",
                action: "AddToCart",
                method: "post",
                debug: true,
                body: JSON.stringify({CourseID: course}),
                success: (result) => {
                    if (result.success) {
                        this.loadCart();
                        this.setState({loaded: true})
                    } 
                    else 
                    {
                        this.setState({loaded: true})
                    }
                },
                error: (err) => {
                    this.setState({loaded: true})
                }
            })
        });
    }
    removeFromCart(e, course)
    {
        e.preventDefault();
        this.setState({loaded: false}, () => {
            this.state.api.send({
                controller: "Cart",
                action: "RemoveFromCart",
                method: "post",
                debug: true,
                body: JSON.stringify({CourseID: course}),
                success: (result) => {
                    if (result.success) 
                    {
                        this.loadCart();
                        this.setState({loaded: true})
                    }
                    else
                    {
                        this.setState({loaded: true});
                    }
                },
                error: (err) => {
                    this.setState({loaded: true});
                }
            })
        });
    }
    clearCart(e)
    {
        this.setState({loaded: false}, () => {
            this.state.api.send({
                controller: "Cart",
                action: "EmptyCart",
                method: "get",
                success: (result) => {
                    result.success ? 
                        this.loadCart() :
                        this.setState({loaded: true})
                },
                error: (err) => {
                    this.setState({loaded: true});
                }
            })
        });
    }
    buytypeChanged(val)
    {
        var cart = this.state.cart;
        cart.loaded = false;
        this.setState({cart: cart}, () => {
            this.state.api.send({
                controller: "Cart",
                action: "ChangeBuyType",
                method: "post",
                body: JSON.stringify ({buyType: val}),
                success: (result) => {
                    if (result.success)
                    {
                        var cart = this.state.cart;
                        cart.buyType = val;
                        this.setState({cart: cart}, () => this.calcPrice());
                    }
                }, error: (err) => { }
            })
        });
    }
    checkCartUserChanged(checked, uid)
    {
        var cart = this.state.cart;
        cart.loaded = false;
        this.setState({cart: cart}, () => {
            if ((checked && cart.cartUsers.indexOf(uid) === -1) || 
                (!checked && cart.cartUsers.indexOf(uid) !== -1))
            {
                this.state.api.send({
                    controller: "Cart",
                    action: checked ? "AddUserToCart" : "RemoveUserFromCart",
                    method: "post",
                    body: JSON.stringify({userID: uid}),
                    success: (result) => {
                        if (result.success)
                        {
                            console.dir(cart);
                            if (checked)
                            {
                                cart.cartUsers.push(uid);
                                cart.loaded = true;
                                this.setState({cart: cart}, () => { this.calcPrice() });
                            }
                            else
                            {
                                var idx = cart.cartUsers.indexOf(uid);
                                cart.cartUsers.splice(idx, 1);
                                cart.loaded = true;
                                this.setState({cart: cart}, () => { this.calcPrice() });
                            }
                        }
                    },
                    error: (err) => { }
                });
            }
        });
    }
    cartUserSelectAll()
    {
        var cart = this.state.cart;
        cart.loaded = false;
        this.setState({cart: cart}, () => {
            this.state.api.send({
                controller: "Cart",
                action: "AddAllUsersToCart",
                method: "get",
                success: (result) => {
                    this.state.orgUsers.forEach((u) => {
                        if (cart.cartUsers.indexOf(u.userID) === -1)
                        {
                            cart.cartUsers.push(u.userID);
                        }
                    })
                    cart.loaded = true;
                    this.setState({cart: cart}, () => { this.calcPrice() });
                },
                error: (err) => { }
            })
        })
    }
    cartUserDeselectAll()
    {
        var cart = this.state.cart;
        cart.loaded = false;
        this.setState({cart: cart}, () => {
            this.state.api.send({
                controller: "Cart",
                action: "RemoveAllUsersFromCart",
                method: "get",
                success: (result) => {
                    cart.cartUsers = [];
                    cart.loaded = true;
                    this.setState({cart: cart}, () => { this.calcPrice() });
                },
                error: (err) => { }
            })
        })
    }
    render()
    {
        return (
            <div className="lmsapp">
                <BrowserRouter>
                    <Switch>
                        <Route path="/exam/:id" render={(routeprops) =>
                            <Course api={this.state.api} courseID={routeprops.match.params.id} />
                        } />
                        <Route path="/Forms/view/:id" render={(routerprops) =>
                            <FormViewer api={this.state.api} id={routerprops.match.params.id} />
                        } />
                        <Route path="/Shop/Embed" render={(routerprops) =>
                            <CourseCatalogEmbed api={this.state.api} cart={this.state.cart} addToCart={this.addToCart} removeFromCart={this.removeFromCart} />
                        } />
                        <Route path="/">
                            <div className="lmsroutercontainer">
                                <Header authenticated={this.state.authenticated} onLogout={this.logout} loaded={this.state.loaded} cartcourses={this.state.cartCourses} />
                                <div className="lmscontainer">
                                    <div className="lmscontainerinner">
                                        { this.state.loaded ? 
                                            this.state.authenticated ? 
                                                this.state.changepassword ?
                                                    (
                                                        <PasswordChange api={this.state.api} onChange={this.passwordChanged} />
                                                    ) : (
                                                        <div>
                                                            <Navigation api={this.state.api} />
                                                            <LMSMain api={this.state.api} cart={this.state.cart} orgUsers={this.state.orgUsers} addToCart={this.addToCart} 
                                                                removeFromCart={this.removeFromCart} clearCart={this.clearCart}
                                                                buyTypeChanged={this.buytypeChanged} checkCartUserChanged={this.checkCartUserChanged}
                                                                cartUserSelectAll={this.cartUserSelectAll} cartUserDeselectAll={this.cartUserDeselectAll} />
                                                            <div className="lmsclear"><span></span></div>
                                                        </div>
                                                    ) 
                                                : (
                                                    <Switch>
                                                        <Route path="/Courses/:id" render={(routerprops) =>
                                                            <CourseInfo api={this.state.api} courseID={routerprops.match.params.id}
                                                                cart={this.state.cart} addToCart={this.addToCart}
                                                                removeFromCart={this.removeFromCart} />
                                                        } />
                                                        <Route exact path="/Register" render={(routerprops) =>
                                                            <Register api={this.state.api} />
                                                        } />
                                                        <Route exact path="/PasswordReset" render={(routerprops) =>
                                                            <ResetPassword api={this.state.api} />
                                                        } />
                                                        <Route path="/Login" render={(routerprops) =>
                                                            <Login api={this.state.api} onSubmit={this.authenticate} />
                                                        } />
                                                        <Route path="/Cart/:id" render={(routerprops) =>
                                                            <Cart api={this.state.api} cart={this.state.cart}
                                                                addToCart={this.addToCart} removeFromCart={this.removeFromCart}
                                                                clearCart={this.clearCart} orgUsers={this.state.orgUsers}
                                                                buyTypeChanged={this.buyTypeChanged} checkCartUserChanged={this.checkCartUserChanged}
                                                                cartUserSelectAll={this.cartUserSelectAll} cartUserDeselectAll={this.cartUserDeselectAll}
                                                                anonymousCart={true} courseId={routerprops.match.params.id} loadCart={this.loadCart} />
                                                        } />
                                                        <Route path="/Cart" render={(routerprops) =>
                                                            <Cart api={this.state.api} cart={this.state.cart}
                                                                addToCart={this.addToCart} removeFromCart={this.removeFromCart}
                                                                clearCart={this.clearCart} orgUsers={this.state.orgUsers}
                                                                buyTypeChanged={this.buyTypeChanged} checkCartUserChanged={this.checkCartUserChanged}
                                                                cartUserSelectAll={this.cartUserSelectAll} cartUserDeselectAll={this.cartUserDeselectAll}
                                                                anonymousCart={true} />
                                                        } />
                                                        <Route path="/" render={(routerprops) =>
                                                            <CourseCatalog api={this.state.api} cart={this.state.cart} addToCart={this.addToCart} removeFromCart={this.removeFromCart} /> 
                                                        } />
                                                    </Switch>
                                            )
                                        : (
                                            <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Route>
                    </Switch>
                </BrowserRouter>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/general/app.js